;(function() {
  const hasScrolledClsn = 'has-scrolled-header-threshold';
  const noTransitionClsn = 'no-transition';
  const hasScrolledThreshold = 45;
  const body = document.body;
  const pageHeader = body.querySelector('body > header');
  const mainNavBar = body.querySelector('.nav-top');
  const onceOptions = { once: true };

  if (pageHeader) {
    window.addEventListener('resize', () => cancelTransition(), false);
    document.addEventListener('scroll', event => onScroll(), false);
  }

  /**
   * Cancel transition.
   */
  function cancelTransition() {
    updateTransitionEventHandlers(true);
    body.classList.add(noTransitionClsn);
    window.requestAnimationFrame(() => dispatchRepad());
  }

  /**
   * Trigger Equinoxe's repadding callback.
   */
  function dispatchRepad() {
    document.body.dispatchEvent(new CustomEvent('repad'));
    body.classList.remove(noTransitionClsn);
    updateTransitionEventHandlers(false);
  }

  /**
   * Handle scrolling.
   */
  function onScroll() {
    body.classList.toggle(hasScrolledClsn, window.scrollY > hasScrolledThreshold);
  }

  /**
   * @param {boolean} [add = false] - Whether to add or remove the event listeners
   */
  function updateTransitionEventHandlers(add = false) {
    const method = add ? 'addEventListener' : 'removeEventListener';

    pageHeader[method]('transitioncancel', () => dispatchRepad(), onceOptions);
    pageHeader[method]('transitionend', () => dispatchRepad(), onceOptions);
    mainNavBar?.[method]('transitioncancel', () => dispatchRepad(), onceOptions);
    mainNavBar?.[method]('transitionend', () => dispatchRepad(), onceOptions);
  }
}());
